import Cryptr from 'cryptr';
import { toast } from 'react-toastify';
import moment from 'moment';
import 'react-toastify/dist/ReactToastify.css';
import CONSTANTS from './Constants';

const LOCALHOST_PREFIX = 'spikeviewcryptlib_'; 
const ENCRYPTION_KEY = 'sd5b75nb7577#^%$%*&G#CGF*&%@#%*&';
var cryptlib = require('cryptlib'),
  iv = 'F@$%^*GD$*(*#!12', //16 bytes = 128 bit
  //iv = crypto.randomBytes(16),
  key = cryptlib.getHashSha256(ENCRYPTION_KEY, 32); //32 bytes = 256 bits

const cryptr = new Cryptr(CONSTANTS.CRYPTER_KEY);
let toastId = '';

// export const validateDomain = (email, domainArr) => {
//   // let match = email.match(/^\w+@(\w+).\w+$/);
//   // return match!==null &&  match[1]===domainArr;
//   console.log("yig", domainArr);
//   let temp = false;
//   domainArr.map((itm) => {
//     if (email.includes(itm)) {
//       temp = true;
//     }
//   });
//   return temp;
// };

export const validateDomain = (email, domainArray) => {
  if (email && domainArray) {
    // var domain = email.split('@')[1].split('.')[1];
    // return domainArray.includes(domain);
    var emailSplit = email.split('@')[1].split('.');
    if (emailSplit) {
      var domainLength = emailSplit.length - 1;
      var domain = emailSplit[domainLength];
      return domainArray.includes(domain);
    }
  }
};

export const encrypt = (text) => {
  let cryptText = cryptlib.encrypt(text, key, iv);
  return cryptText.replace(/\//g, '_spike_');
};

export const decrypt = (text) => {
  let decrptText = text.replace(/_spike_/g, '/');
  return cryptlib.decrypt(decrptText, key, iv);
};

//used to encryption of localstorage data
export const encryptedData = (data) => {
  return cryptr.encrypt(data);
};

//used to decrypt localstorage data
export const decryptedData = (data) => {
  return cryptr.decrypt(data);
};

// toastr messages for error
let toastTimer = null;
export const showErrorToast = (errorMessage, event) => {
  if (toastTimer) {
    clearTimeout(toastTimer);
  }

  toastTimer = setTimeout(() => {
    toast.dismiss();

    toast.error(errorMessage, {
      position: toast.POSITION.TOP_RIGHT,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
    });
  }, 300);
};

// toastr messages for success
export const showSuccessToast = (message) => {
  if (toastTimer) {
    clearTimeout(toastTimer);
  }

  toastTimer = setTimeout(() => {
    toast.dismiss();

    toast.success(message, {
      position: toast.POSITION.TOP_RIGHT,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
    });
  }, 300);
};

export const setLocalStorage = (key, value) => {
  value = JSON.stringify(value);
  const encodedData = encryptedData(value);
  localStorage.setItem(LOCALHOST_PREFIX+key, encodedData);
};

const generateRandomString = () => {
  var text = '';
  var possible =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  for (var i = 0; i < 5; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
};

export const generateTimestamp = (fileName) => {
  let extension = fileName.split('.').pop();
  let newFileName =
    moment().valueOf() + generateRandomString() + '.' + extension;
  return newFileName;
};
// used to get localstorage item
export const getLocalStorage = (key) => {
  if (key) {
    let data = localStorage.getItem(LOCALHOST_PREFIX+key);
    if (data) {
      data = JSON.parse(decryptedData(data));
      return data;
    }
  }
  return null;
};

// used to remove localstorage item
export const removeLocalStorage = (key) => {
  localStorage.removeItem(LOCALHOST_PREFIX+key);
};

// used to clear localstorage
export const clearLocalStorage = () => {
  localStorage.clear();
};

export const isValidURL = (URL) => {
  var regexp =
    /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
  return regexp.test(URL);
};

export const isURL = (str) => {
  var pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i'
  ); // fragment locator
  return pattern.test(str);
};

// export const extractURL = str => {
//   var urlRegex = /(https?:\/\/[^\s]+)/g;
//   var linkText = str.match(urlRegex);
//   return linkText;
// };

export const extractURL = (str) => {
  let getString = Array.isArray(str) ? str[0] : str;

  if (getString) {
    var urlRegex = /(https?:\/\/[^\s]+)/g;

    var linkText = getString.match(urlRegex);

    if (Array.isArray(linkText)) {
      return linkText[0];
    } else {
      return linkText;
    }
  }
  return false;
};

export const isLinkExist = (str) => {
  if (str) {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    var linkText = str.match(urlRegex);
    if (linkText) {
      return true;
    } else {
      return false;
    }
  }
};

export const isExistURL = (URL) => {
  // var regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
  var regexp = /(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w\.-]*)*\/?\S/;
  return regexp.test(URL);
};

export const capitalize = (s) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const uploadToAzure = (
  type,
  userId,
  file,
  uploadPath,
  sasToken,
  callback
) => {
  if (file !== '') {
    let AzureStorage = window.AzureStorage;

    let folderName =
      type === 1 ? CONSTANTS.AZURE_ALBUM.ADMIN : CONSTANTS.AZURE_ALBUM.ADMIN;
    let fileName = generateTimestamp(file.name);
    let uploadPath = `sv_${userId}/${folderName}/${fileName}`;
    const blobService = AzureStorage.Blob.createBlobServiceWithSas(
      CONSTANTS.azureBlobURI,
      sasToken
    );

    blobService.createBlockBlobFromBrowserFile(
      CONSTANTS.azureContainer,
      uploadPath,
      file,
      (error, result) => {
        if (callback) callback(error, result, uploadPath, fileName);

        if (error) {
          console.log('error ', error);
        }
      }
    );
  }
};

export const mediaFeedUploadToAzure = (
  type,
  userId,
  file,
  uploadPath,
  sasToken,
  callback
) => {
  if (file !== '') {
    let AzureStorage = window.AzureStorage;

    const blobService = AzureStorage.Blob.createBlobServiceWithSas(
      CONSTANTS.azureBlobURI,
      sasToken
    );

    var customBlockSize =
      file.size > 1024 * 1024 * 32 ? 1024 * 1024 * 4 : 1024 * 512;
    blobService.singleBlobPutThresholdInBytes = customBlockSize;

    var speedSummary = blobService.createBlockBlobFromBrowserFile(
      CONSTANTS.azureContainer,
      uploadPath,
      file,
      { blockSize: customBlockSize },
      (error, result) => {
        if (callback)
          callback(
            error,
            result,
            uploadPath,
            // new changes
            speedSummary.on('progress', function () {
              speedSummary.getCompletePercent(2);
            })
            // new changes
          );
        if (error) {
          console.log('error ', error);
        }
      }
    );
  }
};

export const base64Encoding = (str) => {
  if (str === '' || str.trim() === '') {
    return false;
  } else {
    return btoa(str);
  }
};

export const base64Decoding = (str) => {
  if (str === '' || str.trim() === '') {
    return false;
  } else {
    return atob(str);
  }
};

export const dateFormat = (str) => {
  if (str) {
    return moment(str).format('MMMM Do, YYYY');
  }
};

export const timeFormat = (str) => {
  if (str) {
    return moment(str).format('h:mm A');
  }
};

export const addBreakWithString = (str) => {
  if (str) {
    return str.replace(/\n/g, '<br/>');
  }
};

export const removeDuplicateObjects = (originalArray, property) => {
  let uniqueArray = [];
  let uniqueObject = {};

  originalArray.forEach(function (obj) {
    if (!uniqueObject[obj[property]]) {
      uniqueObject[obj[property]] = obj;
    }
  });

  for (let key in uniqueObject) {
    uniqueArray.push(uniqueObject[key]);
  }

  return uniqueArray;
};

export const getUserRoleById = (roleId) => {
  let getUser = CONSTANTS.ROLE_DESCRIPTION.find(
    (users) => users.roleId === roleId
  );
  return getUser.title;
};

export const checkDomainArray = (email, domainArray) => {
  if (email && domainArray) {
    // var domain = email.split('@')[1].split('.')[1];
    // return domainArray.includes(domain);
    var emailSplit = email.split('@')[1].split('.');
    if (emailSplit) {
      var domainLength = emailSplit.length - 1;
      var domain = emailSplit[domainLength];
      return domainArray.includes(domain);
    }
  }
};

export const getAllGrades = () => {
  const options = [
    { value: "0", label: "kth" },
    { value: "1", label: "1st" },
    { value: "2", label: "2nd" },
    { value: "3", label: "3rd" },
    { value: "4", label: "4th" },
    { value: "5", label: "5th" },
    { value: "6", label: "6th" },
    { value: "7", label: "7th" },
    { value: "8", label: "8th" },
    { value: "9", label: "9th" },
    { value: "10", label: "10th" },
    { value: "11", label: "11th" },
    { value: "12", label: "12th" },
  ];

  return options;
};
export const getGradeName = (id) => {
  const grades = getAllGrades();
  return grades.find((grade) => grade.value === String(id))?.label || null;
};